import { KanbanBoardStatus } from 'views/pages/dashboard/KanbanQuestions/constants';
import * as actionTypes from './actions';
import { v4 as uuidv4 } from 'uuid';
export const initialState = {
    categoryId: [],
    currentPage: 1,
    enquiryStatus: 'outstanding',
    enquiryCategories: {},
    investorStatus: null,
    items: [],
    teamMembersProfile: [],
    itemsPerPage: 10,
    loading: true,
    message: '',
    catModal: false,
    editCatModal: false,
    selectedItems: [],
    sortDir: 'desc',
    totalItems: 1,
    refreshData: false,
    addCategory: false,
    modalStatus: false,
    modalType: '',
    singleItem: true,
    updateCategory: {},
    searchText: '',
    outstandingQuestions: 0,
    catSearchText: '',
    userSearchText: '',
    currentQuestionData: {},
    selectedTemplate: {},
    viewTemplate: {},
    isLoading: true,
    assignee: [],
    isConfirmationModalOpen: false,
    isCategoryAddedRemovedRefresh: false,
    isCategoryAddedRemovedRefreshLoading: false,
    lockedQuestionRegistryAddCount: 0,
    topMenuThreeDotsOpen: false,
    outstandingAssignee: [],
    outstandingCategory: [],
    outstandingInvestorStatus: null,
    outstandingErrorMessage: '',
    outstandingCurrentPage: 1,
    outstandingItemsPerPage: 25,
    outstandingSelectedItems: [],
    outstandingSortDir: 'desc',
    isOutstandingThreeDotsItemClicked: false,
    isOutstandingLoading: false,
    outstandingTotalPages: 1,
    outstandingTotalItems: 0,
    draftedAssignee: [],
    draftedCategory: [],
    draftedInvestorStatus: null,
    draftedErrorMessage: '',
    draftedCurrentPage: 1,
    draftedItemsPerPage: 10,
    draftedSelectedItems: [],
    draftedTotalItems: 0,
    draftedSortDir: 'desc',
    isDraftedThreeDotsItemClicked: false,
    isDraftedLoading: false,
    draftedTotalPages: 1,
    resolvedTotalItems: 0,
    resolvedAssignee: [],
    resolvedCategory: [],
    resolvedInvestorStatus: null,
    resolvedErrorMessage: '',
    resolvedCurrentPage: 1,
    resolvedItemsPerPage: 10,
    resolvedSelectedItems: [],
    resolvedSortDir: 'desc',
    isResolvedThreeDotsItemClicked: false,
    isResolvedLoading: false,
    resolvedTotalPages: 1,
    archivedTotalItems: 0,
    archivedAssignee: null,
    archivedCategory: null,
    archivedInvestorStatus: null,
    archivedErrorMessage: '',
    archivedCurrentPage: 1,
    archivedItemsPerPage: 6,
    archivedSelectedItems: [],
    archivedSortDir: 'desc',
    isArchivedThreeDotsItemClicked: false,
    isArchivedLoading: false,
    outstandingWidth: 0,
    resolvedWidth: 0,
    draftedWidth: 0,
    incrementResolvedWidth: 0,
    incrementDraftedWidth: 0,
    incrementOutstandingWidth: 0,
    isOutstandingBoardExtended: false,
    isDraftedBoardExtended: false,
    isResolvedBoardExtended: false,
    outstandingClientWidth: 0,
    draftedClientWidth: 0,
    resolvedClientWidth: 0,
    archivedTotalPages: 1,
    selectedIdToView: null,
    reload: false,
    isInvestoryHistoryOpen: false,
    isReOpenQuestion: false,
    isQuickResponseOpen: false,
    showHideSampleQuestionMessage: false,
    categoryIds: [],
    assigneeIds: [],
    isOutstandingReload: false,
    isDraftedReload: false,
    isResolveReload: false,
    isOutstandingUpdatesReload: false,
    isResolvedUpdatesReload: false,
    isDraftedUpdatesReload: false,
    isUdpatesForThreeDots: false,
    isUpdatesForViewItems: false,
    isMultipleCategory: false,
    isMulitpleAssigne: false,
    threeDotsTarget: null,
    updatesForArchive: false,
    selectedIdForTaskThreeDots: null,
    isUpdatesForArchived: false,
    hasViewedQuickResponseInfo: false,
    selectedQuestionRegistryId: null,
    totalUnlockedRegistries: 0,
    totalLockedRegistries: 0,
    isEnquiryReplyLoading: false,
    enquiryReplyPerPageItem: 1000,
    enquiryReplyCurrentPage: 1,
    enquiryReplyTotalItems: 0,
    enquiryReplyTotalPages: 1,
    reloadReply: false,
    enquiryReplyList: [],
    isReplyFromEdit: false,
    attachments: [],
    enquiryCategoryReload: false,
    isSelectAllCardOutstanding: false,
    isSelectAllCardActive: false,
    isSelectAllCardResolved: false,
    isIndeterminateStateOutstanding: false,
    isIndeterminateStateActive: false,
    isIndeterminateStateResolved: false,
    selectedCards: [],
    assignedMembersCards: [],
    assignedCategoriesCards: [],
    selectedExportToPdf: [],
    isSelectClicked: false,
    isEnquiryReplied: false,
    selectedCategoryEdit: {},
    isCreatedOrEdit: false,
    reloadCategories: false,
    boardItems: {
        [uuidv4()]: {
            title: KanbanBoardStatus.outstanding,
            items: []
        },
        [uuidv4()]: {
            title: KanbanBoardStatus.drafted,
            items: []
        },
        [uuidv4()]: {
            title: KanbanBoardStatus.resolved,
            items: []
        }
    },
    viewQuestionDetailModalStatus: false,
    questionContent: '',
    submittingData: null,
    showDialogCloseConfirmation: false,
    noteDetail: {},
    selectedNode: null,
    isTyped: false,
    inputNote: null
};
let dummy_items = null;

const questionReducer = (state = initialState, action) => {
    let id;
    switch (action.type) {
        case actionTypes.setCategoryId:
            return {
                ...state,
                categoryId: action.categoryId
            };
        case actionTypes.setCategoryIds:
            return {
                ...state,
                categoryIds: action.categoryIds
            };
        case actionTypes.setAssigneeIds:
            return {
                ...state,
                assigneeIds: action.assigneeIds
            };
        case actionTypes.setCurrentPage:
            return {
                ...state,
                currentPage: action.currentPage
            };
        case actionTypes.setEnquiryStatus:
            return {
                ...state,
                enquiryStatus: action.enquiryStatus
            };
        case actionTypes.setEnquiryCategories:
            return {
                ...state,
                enquiryCategories: action.enquiryCategories
            };
        case actionTypes.setInvestorStatus:
            return {
                ...state,
                investorStatus: action.investorStatus
            };
        case actionTypes.setItems:
            return {
                ...state,
                items: action.items
            };
        case actionTypes.setTeamMembersProfile:
            let id = action.id;
            let profile = action.profile;
            let teamMembersProfileNew = state.teamMembersProfile;
            return {
                ...state,
                teamMembersProfile: { ...teamMembersProfileNew, [id]: profile }
            };
        case actionTypes.setTeamMembers:
            return {
                ...state,
                teamMembers: action.teamMembers
            };
        case actionTypes.setItemsPerPage:
            return {
                ...state,
                itemsPerPage: action.itemsPerPage
            };
        case actionTypes.setSingleItem:
            return {
                ...state,
                singleItem: action.singleItem
            };
        case actionTypes.setLoading:
            return {
                ...state,
                loading: action.loading
            };
        case actionTypes.setMessage:
            return {
                ...state,
                message: action.message
            };
        case actionTypes.setSelectedItems:
            if (action.singleItem === false) {
                if (action.singleItem !== state.singleItem) {
                    dummy_items = [];
                }
                if (action.action && action.action === 'remove') {
                    dummy_items = dummy_items.filter(function (value, index, arr) {
                        return value != action.selectedItems;
                    });
                } else {
                    dummy_items.push(action.selectedItems);
                }
            } else {
                dummy_items = action.selectedItems;
            }
            return {
                ...state,
                selectedItems: dummy_items,
                singleItem: action.singleItem
            };
        case actionTypes.setSortDir:
            return {
                ...state,
                sortDir: action.sortDir
            };
        case actionTypes.setTotalItems:
            return {
                ...state,
                totalItems: action.totalItems
            };
        case actionTypes.setRefreshData:
            return {
                ...state,
                refreshData: action.refreshData
            };
        case actionTypes.setModalStatus:
            return {
                ...state,
                modalStatus: action.modalStatus
            };
        case actionTypes.setModalType:
            return {
                ...state,
                modalType: action.modalType
            };
        case actionTypes.setUpdateCategory:
            return {
                ...state,
                updateCategory: action.updateCategory
            };
        case actionTypes.setOutstandingQuestions:
            return {
                ...state,
                outstandingQuestions: action.outstandingQuestions
            };
        case actionTypes.setSearchText:
            return {
                ...state,
                searchText: action.searchText
            };
        case actionTypes.setCatSearchText:
            return {
                ...state,
                catSearchText: action.catSearchText
            };
        case actionTypes.setUserSearchText:
            return {
                ...state,
                userSearchText: action.userSearchText
            };
        case actionTypes.setCurrentQuestionData:
            return {
                ...state,
                currentQuestionData: action.currentQuestionData
            };
        case actionTypes.setSelectedTemplate:
            return {
                ...state,
                selectedTemplate: action.selectedTemplate
            };
        case actionTypes.setIsLoading:
            return {
                ...state,
                isLoading: action.isLoading
            };
        case actionTypes.setAssignee: {
            return {
                ...state,
                assignee: action.assignee
            };
        }
        case actionTypes.setViewTemplate: {
            return {
                ...state,
                viewTemplate: action.viewTemplate
            };
        }
        case actionTypes.setIsConfirmationModalOpen:
            return {
                ...state,
                isConfirmationModalOpen: action.isConfirmationModalOpen
            };
        case actionTypes.setIsCategoryAddedRemovedRefresh:
            return {
                ...state,
                isCategoryAddedRemovedRefresh: action.isCategoryAddedRemovedRefresh
            };
        case actionTypes.setIsCategoryAddedRemovedRefreshLoading:
            return {
                ...state,
                isCategoryAddedRemovedRefreshLoading: action.isCategoryAddedRemovedRefreshLoading
            };
        case actionTypes.setLockedAddToRegistryQuestionCount:
            return {
                ...state,
                lockedQuestionRegistryAddCount: action.lockedQuestionRegistryAddCount
            };
        case actionTypes.setTopThreeDotItemsOpen:
            return {
                ...state,
                topMenuThreeDotsOpen: action.topMenuThreeDotsOpen
            };
        case actionTypes.setOutstandingAssignee:
            return {
                ...state,
                outstandingAssignee: action.outstandingAssignee
            };
        case actionTypes.setOutstandingCategory:
            return {
                ...state,
                outstandingCategory: action.outstandingCategory
            };
        case actionTypes.setOutstandingCurrentPage:
            return {
                ...state,
                outstandingCurrentPage: action.outstandingCurrentPage
            };
        case actionTypes.setOutstandingErrorMessage:
            return {
                ...state,
                outstandingErrorMessage: action.outstandingErrorMessage
            };
        case actionTypes.setOutstandingInvestorStatus:
            return {
                ...state,
                outstandingInvestorStatus: action.outstandingInvestorStatus
            };
        case actionTypes.setOutstandingItemsPerPage:
            return {
                ...state,
                outstandingItemsPerPage: action.outstandingItemsPerPage
            };
        case actionTypes.setOutstandingSelectedItems:
            return {
                ...state,
                outstandingSelectedItems: action.outstandingSelectedItems
            };
        case actionTypes.setIsOutstandingThreeDotsItemClicked:
            return {
                ...state,
                isOutstandingThreeDotsItemClicked: action.isOutstandingThreeDotsItemClicked
            };
        case actionTypes.setOutstandingTotalItems:
            return {
                ...state,
                outstandingTotalItems: action.outstandingTotalItems
            };
        case actionTypes.setIsOutstandingLoading:
            return {
                ...state,
                isOutstandingLoading: action.isOutstandingLoading
            };
        case actionTypes.setOutstandingSortDir:
            return {
                ...state,
                outstandingSortDir: action.outstandingSortDir
            };
        //Drafted
        case actionTypes.setDraftedAssignee:
            return {
                ...state,
                draftedAssignee: action.draftedAssignee
            };
        case actionTypes.setDraftedCategory:
            return {
                ...state,
                draftedCategory: action.draftedCategory
            };
        case actionTypes.setDraftedCurrentPage:
            return {
                ...state,
                draftedCurrentPage: action.draftedCurrentPage
            };
        case actionTypes.setDraftedErrorMessage:
            return {
                ...state,
                draftedErrorMessage: action.draftedErrorMessage
            };
        case actionTypes.setDraftedInvestorStatus:
            return {
                ...state,
                draftedInvestorStatus: action.draftedInvestorStatus
            };
        case actionTypes.setDraftedItemsPerPage:
            return {
                ...state,
                draftedItemsPerPage: action.draftedItemsPerPage
            };
        case actionTypes.setDraftedSelectedItems:
            return {
                ...state,
                draftedSelectedItems: action.draftedSelectedItems
            };
        case actionTypes.setIsDraftedThreeDotsItemClicked:
            return {
                ...state,
                isDraftedThreeDotsItemClicked: action.isDraftedThreeDotsItemClicked
            };
        case actionTypes.setDraftedTotalItems:
            return {
                ...state,
                draftedTotalItems: action.draftedTotalItems
            };
        case actionTypes.setIsDraftedLoading:
            return {
                ...state,
                isDraftedLoading: action.isDraftedLoading
            };
        case actionTypes.setDraftedSortDir:
            return {
                ...state,
                draftedSortDir: action.draftedSortDir
            };
        //Resolved
        case actionTypes.setResolvedAssignee:
            return {
                ...state,
                resolvedAssignee: action.resolvedAssignee
            };
        case actionTypes.setResolvedCategory:
            return {
                ...state,
                resolvedCategory: action.resolvedCategory
            };
        case actionTypes.setResolvedCurrentPage:
            return {
                ...state,
                resolvedCurrentPage: action.resolvedCurrentPage
            };
        case actionTypes.setResolvedErrorMessage:
            return {
                ...state,
                resolvedErrorMessage: action.resolvedErrorMessage
            };
        case actionTypes.setResolvedInvestorStatus:
            return {
                ...state,
                resolvedInvestorStatus: action.resolvedInvestorStatus
            };
        case actionTypes.setResolvedItemsPerPage:
            return {
                ...state,
                resolvedItemsPerPage: action.resolvedItemsPerPage
            };
        case actionTypes.setResolvedSelectedItems:
            return {
                ...state,
                resolvedSelectedItems: action.resolvedSelectedItems
            };
        case actionTypes.setIsResolvedThreeDotsItemClicked:
            return {
                ...state,
                isResolvedThreeDotsItemClicked: action.isResolvedThreeDotsItemClicked
            };
        case actionTypes.setResolvedTotalItems:
            return {
                ...state,
                resolvedTotalItems: action.resolvedTotalItems
            };
        case actionTypes.setIsResolvedLoading:
            return {
                ...state,
                isResolvedLoading: action.isResolvedLoading
            };
        case actionTypes.setResolvedSortDir:
            return {
                ...state,
                resolvedSortDir: action.resolvedSortDir
            };
        /**Total Pages and board items */
        case actionTypes.setAllBoardItems:
            return {
                ...state,
                boardItems: action.boardItems
            };
        case actionTypes.setResolvedTotalPages:
            return {
                ...state,
                resolvedTotalPages: action.resolvedTotalPages
            };
        case actionTypes.setDraftedTotalPages:
            return {
                ...state,
                draftedTotalPages: action.draftedTotalPages
            };
        case actionTypes.setOutstandingTotalPages:
            return {
                ...state,
                outstandingTotalPages: action.outstandingTotalPages
            };

        //Archived
        case actionTypes.setArchivedAssignee:
            return {
                ...state,
                archivedAssignee: action.archivedAssignee
            };
        case actionTypes.setArchivedCategory:
            return {
                ...state,
                archivedCategory: action.archivedCategory
            };
        case actionTypes.setArchivedCurrentPage:
            return {
                ...state,
                archivedCurrentPage: action.archivedCurrentPage
            };
        case actionTypes.setArchivedErrorMessage:
            return {
                ...state,
                archivedErrorMessage: action.archivedErrorMessage
            };
        case actionTypes.setArchivedInvestorStatus:
            return {
                ...state,
                archivedInvestorStatus: action.archivedInvestorStatus
            };
        case actionTypes.setArchivedItemsPerPage:
            return {
                ...state,
                archivedItemsPerPage: action.archivedItemsPerPage
            };
        case actionTypes.setArchivedSelectedItems:
            return {
                ...state,
                archivedSelectedItems: action.archivedSelectedItems
            };
        case actionTypes.setIsArchivedThreeDotsItemClicked:
            return {
                ...state,
                isArchivedThreeDotsItemClicked: action.isArchivedThreeDotsItemClicked
            };
        case actionTypes.setArchivedTotalItems:
            return {
                ...state,
                archivedTotalItems: action.archivedTotalItems
            };
        case actionTypes.setIsArchivedLoading:
            return {
                ...state,
                isArchivedLoading: action.isArchivedLoading
            };
        case actionTypes.setArchivedSortDir:
            return {
                ...state,
                archivedSortDir: action.archivedSortDir
            };
        case actionTypes.setArchivedTotalPages:
            return {
                ...state,
                archivedTotalPages: action.archivedTotalPages
            };
        case actionTypes.setReload:
            return {
                ...state,
                reload: action.reload
            };
        case actionTypes.setSelectedIdtoView:
            return {
                ...state,
                selectedIdToView: action.selectedIdToView
            };
        case actionTypes.setViewQuestionDetailModalStatus:
            return {
                ...state,
                viewQuestionDetailModalStatus: action.viewQuestionDetailModalStatus
            };
        case actionTypes.setIsInvestorHistoryOpen:
            return {
                ...state,
                isInvestoryHistoryOpen: action.isInvestoryHistoryOpen
            };
        case actionTypes.setIsReOpenQuestion:
            return {
                ...state,
                isReOpenQuestion: action.isReOpenQuestion
            };
        case actionTypes.setIsQuickResponseOpen:
            return {
                ...state,
                isQuickResponseOpen: action.isQuickResponseOpen
            };
        case actionTypes.setShowSampleQuestionMessage:
            return {
                ...state,
                showHideSampleQuestionMessage: action.showHideSampleQuestionMessage
            };
        case actionTypes.setOutstandingWidth:
            return {
                ...state,
                outstandingWidth: action.outstandingWidth
            };
        case actionTypes.setDraftedWidth:
            return {
                ...state,
                draftedWidth: action.draftedWidth
            };
        case actionTypes.setResolvedWidth:
            return {
                ...state,
                resolvedWidth: action.resolvedWidth
            };
        case actionTypes.setOutstandingClientWidth:
            return {
                ...state,
                outstandingClientWidth: action.outstandingClientWidth
            };
        case actionTypes.setDraftedClientWidth:
            return {
                ...state,
                draftedClientWidth: action.draftedClientWidth
            };
        case actionTypes.setResolvedClientWidth:
            return {
                ...state,
                resolvedClientWidth: action.resolvedClientWidth
            };
        case actionTypes.setIsOutstandingBoardExtended:
            return {
                ...state,
                isOutstandingBoardExtended: action.isOutstandingBoardExtended
            };
        case actionTypes.setIsDraftedBoardExtended:
            return {
                ...state,
                isDraftedBoardExtended: action.isDraftedBoardExtended
            };
        case actionTypes.setIsResolvedBoardExtended:
            return {
                ...state,
                isResolvedBoardExtended: action.isResolvedBoardExtended
            };
        case actionTypes.setIncrementOutstandingWidth:
            return {
                ...state,
                incrementOutstandingWidth: action.incrementOutstandingWidth
            };
        case actionTypes.setIncrementDraftedWidth:
            return {
                ...state,
                incrementDraftedWidth: action.incrementDraftedWidth
            };
        case actionTypes.setIncrementResolvedWidth:
            return {
                ...state,
                incrementResolvedWidth: action.incrementResolvedWidth
            };
        case actionTypes.setReloadOutstanding:
            return {
                ...state,
                isOutstandingReload: action.isOutstandingReload
            };
        case actionTypes.setReloadtDrafted:
            return {
                ...state,
                isDraftedReload: action.isDraftedReload
            };
        case actionTypes.setReloadResolved:
            return {
                ...state,
                isResolveReload: action.isResolveReload
            };
        case actionTypes.setReloadOutstandingUpdates:
            return {
                ...state,
                isOutstandingUpdatesReload: action.isOutstandingUpdatesReload
            };
        case actionTypes.setReloadtDraftedUpdates:
            return {
                ...state,
                isDraftedUpdatesReload: action.isDraftedUpdatesReload
            };
        case actionTypes.setReloadResolvedUpdates:
            return {
                ...state,
                isResolvedUpdatesReload: action.isResolvedUpdatesReload
            };
        case actionTypes.setIsUpdatesForThreeDots:
            return {
                ...state,
                isUdpatesForThreeDots: action.isUdpatesForThreeDots
            };
        case actionTypes.setIsUpdatesForViewItem:
            return {
                ...state,
                isUpdatesForViewItems: action.isUpdatesForViewItems
            };
        case actionTypes.setIsMultipleAssignee:
            return {
                ...state,
                isMulitpleAssigne: action.isMulitpleAssigne
            };
        case actionTypes.setIsMultipleCategory:
            return {
                ...state,
                isMultipleCategory: action.isMultipleCategory
            };
        case actionTypes.setThreeDotsTarget:
            return {
                ...state,
                threeDotsTarget: action.threeDotsTarget
            };
        case actionTypes.setSelectedIdForTaskThreeDots:
            return {
                ...state,
                selectedIdForTaskThreeDots: action.selectedIdForTaskThreeDots
            };
        case actionTypes.setUpdatesForArchive:
            return {
                ...state,
                updatesForArchive: action.updatesForArchive
            };
        case actionTypes.setIsUpdatesForArchived:
            return {
                ...state,
                isUpdatesForArchived: action.isUpdatesForArchived
            };
        case actionTypes.setHasViewedQuickResponseInfo:
            return {
                ...state,
                hasViewedQuickResponseInfo: action.hasViewedQuickResponseInfo
            };
        case actionTypes.setSelectedQuestionRegistryId:
            return {
                ...state,
                selectedQuestionRegistryId: action.selectedQuestionRegistryId
            };
        case actionTypes.setTotalUnlockedRegistries:
            return {
                ...state,
                totalUnlockedRegistries: action.totalUnlockedRegistries
            };
        case actionTypes.setTotalLockedRegistries:
            return {
                ...state,
                totalLockedRegistries: action.totalLockedRegistries
            };
        case actionTypes.setEnquiryReplyCurrentPage:
            return {
                ...state,
                enquiryReplyCurrentPage: action.enquiryReplyCurrentPage
            };

        case actionTypes.setEnquiryReplyTotalItems:
            return {
                ...state,
                enquiryReplyTotalItems: action.enquiryReplyTotalItems
            };
        case actionTypes.setEnquiryReplyTotalPage:
            return {
                ...state,
                enquiryReplyTotalPages: action.enquiryReplyTotalPages
            };
        case actionTypes.setIsEnquiryReplyLoading:
            return {
                ...state,
                isEnquiryReplyLoading: action.isEnquiryReplyLoading
            };
        case actionTypes.setEnquiryReplyList:
            return {
                ...state,
                enquiryReplyList: action.enquiryReplyList
            };
        case actionTypes.setAttachments:
            return {
                ...state,
                attachments: action.attachments
            };
        case actionTypes.setReloadReply:
            return {
                ...state,
                reloadReply: action.reloadReply
            };
        case actionTypes.setEditFromReply:
            return {
                ...state,
                isReplyFromEdit: action.isReplyFromEdit
            };
        case actionTypes.setEnquiryCategoryReload:
            return {
                ...state,
                enquiryCategoryReload: action.enquiryCategoryReload
            };
        /**Bulk action reducer */
        case actionTypes.setSelectedCards:
            return {
                ...state,
                selectedCards: action.selectedCards
            };
        case actionTypes.setAssignedCategoriesCards:
            return {
                ...state,
                assignedCategoriesCards: action.assignedCategoriesCards
            };
        case actionTypes.setAssignedMembersCards:
            return {
                ...state,
                assignedMembersCards: action.assignedMembersCards
            };
        case actionTypes.setIsSelectAllCardsActive:
            return {
                ...state,
                isSelectAllCardActive: action.isSelectAllCardActive
            };
        case actionTypes.setIsSelectAllCardsOutstanding:
            return {
                ...state,
                isSelectAllCardOutstanding: action.isSelectAllCardOutstanding
            };
        case actionTypes.setIsSelectAllCardsResolved:
            return {
                ...state,
                isSelectAllCardResolved: action.isSelectAllCardResolved
            };
        case actionTypes.setSelectedExportToPdf:
            return {
                ...state,
                selectedExportToPdf: action.selectedExportToPdf
            };
        case actionTypes.setIsSelectClicked:
            return {
                ...state,
                isSelectClicked: action.isSelectClicked
            };
        case actionTypes.setIsEnquiryReplied:
            return {
                ...state,
                isEnquiryReplied: action.isEnquiryReplied
            };
        case actionTypes.setQuestionContent:
            return {
                ...state,
                questionContent: action.questionContent
            };
        case actionTypes.setIsIndeterminateStateOutstanding:
            return {
                ...state,
                isIndeterminateStateOutstanding: action.isIndeterminateStateOutstanding
            };
        case actionTypes.setIsIndeterminateStateActive:
            return {
                ...state,
                isIndeterminateStateActive: action.isIndeterminateStateActive
            };
        case actionTypes.setIsIndeterminateStateResolved:
            return {
                ...state,
                isIndeterminateStateResolved: action.isIndeterminateStateResolved
            };
        case actionTypes.setSubmittingData:
            return {
                ...state,
                submittingData: action.submittingData
            };
        case actionTypes.setDialogCloseConfirmation:
            return {
                ...state,
                showDialogCloseConfirmation: action.showDialogCloseConfirmation
            };
        case actionTypes.setInputNote:
            return {
                ...state,
                inputNote: action.inputNote
            };
        case actionTypes.setIsTyped:
            return {
                ...state,
                isTyped: action.isTyped
            };
        case actionTypes.setSelectedNode:
            return {
                ...state,
                selectedNode: action.selectedNode
            };
        case actionTypes.setNoteDetail:
            return {
                ...state,
                noteDetail: action.noteDetail
            };
        case actionTypes.setSelectedCategoryEdit:
            return {
                ...state,
                selectedCategoryEdit: action.selectedCategoryEdit
            };
        case actionTypes.isCreateOrEditCategory:
            return {
                ...state,
                isCreateOrEdit: action.isCreateOrEdit
            };
        case actionTypes.setReloadCategories:
            return {
                ...state,
                reloadCategories: action.reloadCategories
            };
        default:
            return state;
    }
};

export default questionReducer;
